var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 840 430",
    style: {
      enableBackground: "new 0 0 840 430"
    },
    xmlSpace: "preserve",
    className: "loading-table",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DDDDDD;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_5",
    transform: "translate(70 327.432)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -308.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5v8 C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8c0.8,0,1.5-0.7,1.5-1.5 l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -247.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-2",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-2",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-2",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-2",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-2",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-2",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-2",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-2",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-2",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-2",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-2",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-2",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-2",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -186.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-3",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-3",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-3",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-3",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-3",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-3",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-3",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-3",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-3",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-3",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-3",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-3",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-3",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-3",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -125.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-4",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-4",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-4",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-4",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-4",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-4",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-4",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-4",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-4",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-4",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-4",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-4",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-4",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-4",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -64.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-5",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-5",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-5",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-5",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-5",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-5",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-5",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-5",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-5",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-5",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-5",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-5",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-5",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-5",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -3.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-6",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-6",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-6",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-6",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-6",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-6",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-6",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-6",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-6",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-6",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-6",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-6",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-6",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-6",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 57.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123-7",
    className: "st0",
    d: "M416.5,19h-8c-1.4,0-2.5-1.1-2.5-2.5l0,0v-8c0-1.4,1.1-2.5,2.5-2.5h8c1.4,0,2.5,1.1,2.5,2.5 v8C419,17.9,417.9,19,416.5,19L416.5,19z M408.5,7c-0.8,0-1.5,0.7-1.5,1.5l0,0v8c0,0.8,0.7,1.5,1.5,1.5l0,0h8 c0.8,0,1.5-0.7,1.5-1.5l0,0v-8c0-0.8-0.7-1.5-1.5-1.5l0,0H408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_228-7",
    className: "st0",
    d: "M451,9h41c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-41c-1.1,0-2-0.9-2-2v-4 C449,9.9,449.9,9,451,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229-7",
    className: "st0",
    d: "M596.5-1.5h98c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2h-98c-1.1,0-2-0.9-2-2v-4 C594.5-0.6,595.4-1.5,596.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_230-7",
    className: "st0",
    d: "M596.5,15.5h269c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-269c-1.1,0-2-0.9-2-2v-9 C594.5,16.4,595.4,15.5,596.5,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_231-7",
    className: "st0",
    d: "M950.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C948.5-1.6,949.4-2.5,950.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_232-7",
    className: "st0",
    d: "M950.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C948.5,13.4,949.4,12.5,950.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_233-7",
    className: "st0",
    d: "M1020.5-2.5h32c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-8 C1018.5-1.6,1019.4-2.5,1020.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234-7",
    className: "st0",
    d: "M1020.5,12.5h50c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-50c-1.1,0-2-0.9-2-2v-11 C1018.5,13.4,1019.4,12.5,1020.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235-7",
    className: "st0",
    d: "M1104.5,5.5h68c1.1,0,2,0.9,2,2v11c0,1.1-0.9,2-2,2h-68c-1.1,0-2-0.9-2-2v-11 C1102.5,6.4,1103.4,5.5,1104.5,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236-7",
    className: "st0",
    d: "M1208.5,2.5h11c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2h-11c-1.1,0-2-0.9-2-2v-16 C1206.5,3.4,1207.4,2.5,1208.5,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_237-7",
    className: "st0",
    d: "M517.5,7.5h53c1.1,0,2,0.9,2,2v8c0,1.1-0.9,2-2,2h-53c-1.1,0-2-0.9-2-2v-8 C515.5,8.4,516.4,7.5,517.5,7.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-7",
    className: "st0",
    cx: 438.5,
    cy: 12.5,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238-7",
    x: 1192,
    y: -6,
    className: "st0",
    width: 1,
    height: 37
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317-7",
    x: 398,
    y: 42.6,
    className: "st0",
    width: 840,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingTable);
export default __webpack_public_path__ + "static/media/loading-table.38c560c3947351b0bc91456e9ae51c20.svg";
export { ForwardRef as ReactComponent };